import { replaceDomainForCacheKey, ReportingFunctionArgs, ReportingInfoFuncReturn } from '@americanexpress/fetchye-amex';
import { v4 as generateUUID } from 'uuid';
import { ignoreHeadersByKey } from 'fetchye';
import { MODULE_NAME } from '../constants/commonConstants';
import { PERSONA_CLIENT_ID } from '../constants/apiConstants';
import { getTopCard } from './personaUtils';
import { Membership } from '../types/data.types';

export const generateReporting = (component: string) => (
  { key, options, error }: ReportingFunctionArgs):
    ReportingInfoFuncReturn => ({
  moduleID: MODULE_NAME,
  component,
  fetch: {
    url: key,
    status: error?.status,
    correlationId: options.headers?.['Correlation-ID'] || options.headers?.correlationId || '',
  },
});

export const fetchyeOpts = {
  mapKeyToCacheKey: replaceDomainForCacheKey('oneCMS'),
};

export const personaHeaders = (locale: string) => (
  {
    headers: {
      'Content-Type': 'application/json',
      correlationId: generateUUID(),
      clientId: PERSONA_CLIENT_ID,
      locale,
    },
    mapOptionsToKey: ignoreHeadersByKey(['correlationId']),
  }
);

export const getPersonaAccounts = (membershipApiData?: Membership) => {
  if (!membershipApiData?.membership) {
    return null;
  }
  const accounts: { iaCode: string; isBasic: boolean; }[] = [];
  const topCard = getTopCard(membershipApiData.membership);
  const account = {
    iaCode: topCard?.demographics?.product.productId,
    isBasic: topCard?.demographics?.product.isBasic,
  };
  accounts.push(account);
  return accounts;
};
